module.exports = __webpack_public_path__ + "img/lpr_day_up.3423fe6a.svg";